var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g, _path44, _g2, _path45, _path46, _path47, _g3, _path48, _g4, _path49, _path50, _path51, _path52, _g5, _path53, _g6, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 156,
    viewBox: "0 0 359 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_4309)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.427 64.3545H113.386C112.494 64.3545 111.639 64.7104 111.008 65.3438C110.378 65.9773 110.023 66.8365 110.023 67.7323C110.023 68.6282 110.378 69.4873 111.008 70.1208C111.639 70.7543 112.494 71.1102 113.386 71.1102H119.336V151.918C119.336 152.814 119.69 153.673 120.321 154.307C120.951 154.94 121.806 155.296 122.698 155.296C123.59 155.296 124.445 154.94 125.076 154.307C125.707 153.673 126.061 152.814 126.061 151.918L126.112 71.1102H294.691L310.234 151.918C310.234 152.814 310.589 153.673 311.219 154.307C311.85 154.94 312.705 155.296 313.597 155.296C314.489 155.296 315.344 154.94 315.975 154.307C316.606 153.673 316.96 152.814 316.96 151.918L317.938 71.1102H323.427C324.318 71.1102 325.174 70.7543 325.804 70.1208C326.435 69.4873 326.789 68.6282 326.789 67.7323C326.789 66.8365 326.435 65.9773 325.804 65.3438C325.174 64.7104 324.318 64.3545 323.427 64.3545Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.794 49.3037V63.6078H114.117C113.182 63.6405 112.249 63.4879 111.373 63.1586C110.497 62.8294 109.694 62.33 109.01 61.689C108.325 61.0479 107.774 60.2778 107.386 59.4226C106.998 58.5674 106.781 57.6438 106.749 56.7045C106.716 55.7653 106.868 54.8289 107.196 53.9486C107.524 53.0684 108.021 52.2616 108.659 51.5744C109.297 50.8871 110.064 50.3329 110.915 49.9433C111.767 49.5537 112.686 49.3363 113.621 49.3036C113.786 49.2979 113.952 49.2979 114.117 49.3036L149.794 49.3037Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.67 63.4974C150.67 63.6433 150.612 63.7832 150.51 63.8864C150.407 63.9895 150.268 64.0475 150.123 64.0476H113.481C111.492 64.0462 109.585 63.2514 108.179 61.8381C106.773 60.4247 105.983 58.5084 105.983 56.5103C105.983 54.5123 106.773 52.5959 108.179 51.1826C109.585 49.7693 111.492 48.9745 113.481 48.9731H150.123C150.195 48.973 150.266 48.9871 150.333 49.0146C150.399 49.0422 150.46 49.0827 150.511 49.1338C150.562 49.1849 150.602 49.2456 150.63 49.3124C150.657 49.3793 150.672 49.4509 150.672 49.5233C150.672 49.5957 150.657 49.6673 150.63 49.7342C150.602 49.801 150.562 49.8617 150.511 49.9128C150.46 49.9639 150.399 50.0044 150.333 50.032C150.266 50.0596 150.195 50.0737 150.123 50.0735H113.481C111.784 50.076 110.156 50.7554 108.956 51.9622C107.757 53.1691 107.083 54.8049 107.083 56.5103C107.083 58.2158 107.757 59.8516 108.956 61.0585C110.156 62.2653 111.784 62.9447 113.481 62.9472H150.123C150.268 62.9473 150.407 63.0053 150.51 63.1084C150.612 63.2116 150.67 63.3515 150.67 63.4974Z",
    fill: "#3F3D56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.794 52.6043H111.455C111.426 52.6045 111.398 52.5931 111.377 52.5727C111.357 52.5522 111.345 52.5244 111.345 52.4953C111.344 52.4662 111.356 52.4382 111.376 52.4174C111.396 52.3966 111.424 52.3847 111.453 52.3843H149.794C149.823 52.3846 149.85 52.3963 149.871 52.4169C149.891 52.4375 149.902 52.4653 149.902 52.4943C149.902 52.5233 149.891 52.5511 149.871 52.5717C149.85 52.5923 149.823 52.604 149.794 52.6043Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.794 55.2454H111.455C111.426 55.2456 111.398 55.2342 111.377 55.2138C111.357 55.1934 111.345 55.1655 111.345 55.1364C111.344 55.1073 111.356 55.0793 111.376 55.0585C111.396 55.0377 111.424 55.0258 111.453 55.0254H149.794C149.823 55.0257 149.85 55.0374 149.871 55.058C149.891 55.0786 149.902 55.1064 149.902 55.1354C149.902 55.1644 149.891 55.1922 149.871 55.2128C149.85 55.2334 149.823 55.2452 149.794 55.2454Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.794 57.8861H111.455C111.426 57.8862 111.398 57.8748 111.377 57.8544C111.357 57.834 111.345 57.8062 111.345 57.7771C111.344 57.7479 111.356 57.7199 111.376 57.6991C111.396 57.6783 111.424 57.6664 111.453 57.666H149.794C149.823 57.6663 149.85 57.678 149.871 57.6986C149.891 57.7192 149.902 57.7471 149.902 57.776C149.902 57.805 149.891 57.8329 149.871 57.8535C149.85 57.8741 149.823 57.8858 149.794 57.8861Z",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.794 60.5267H111.455C111.426 60.5268 111.398 60.5155 111.377 60.495C111.357 60.4746 111.345 60.4468 111.345 60.4177C111.344 60.3886 111.356 60.3605 111.376 60.3397C111.396 60.3189 111.424 60.307 111.453 60.3066H149.794C149.823 60.3069 149.85 60.3186 149.871 60.3393C149.891 60.3599 149.902 60.3877 149.902 60.4167C149.902 60.4457 149.891 60.4735 149.871 60.4941C149.85 60.5147 149.823 60.5264 149.794 60.5267Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M143.068 34.2333V48.5375H107.391C105.503 48.6035 103.666 47.9133 102.284 46.6187C100.902 45.324 100.089 43.5311 100.024 41.6342C99.9579 39.7374 100.645 37.892 101.934 36.5041C103.223 35.1161 105.008 34.2993 106.896 34.2333C107.061 34.2276 107.226 34.2276 107.391 34.2333H143.068Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143.945 48.4276C143.945 48.5734 143.887 48.7133 143.784 48.8165C143.682 48.9197 143.542 48.9777 143.397 48.9777H106.756C104.766 48.9777 102.857 48.1836 101.45 46.7701C100.043 45.3566 99.2524 43.4395 99.2524 41.4405C99.2524 39.4415 100.043 37.5244 101.45 36.1109C102.857 34.6974 104.766 33.9033 106.756 33.9033H143.397C143.469 33.9033 143.54 33.9175 143.607 33.9452C143.673 33.9728 143.733 34.0134 143.784 34.0645C143.835 34.1155 143.875 34.1762 143.903 34.2429C143.931 34.3097 143.945 34.3812 143.945 34.4535C143.945 34.5257 143.931 34.5973 143.903 34.664C143.875 34.7308 143.835 34.7914 143.784 34.8425C143.733 34.8936 143.673 34.9341 143.607 34.9618C143.54 34.9894 143.469 35.0036 143.397 35.0036H106.756C105.056 35.0036 103.426 35.6818 102.225 36.889C101.023 38.0961 100.348 39.7334 100.348 41.4405C100.348 43.1477 101.023 44.7849 102.225 45.9921C103.426 47.1992 105.056 47.8774 106.756 47.8774H143.397C143.542 47.8775 143.682 47.9354 143.784 48.0386C143.887 48.1418 143.945 48.2817 143.945 48.4276Z",
    fill: "#3F3D56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.068 37.534H104.729C104.7 37.5342 104.672 37.5228 104.652 37.5024C104.631 37.4819 104.619 37.4541 104.619 37.425C104.619 37.3959 104.63 37.3679 104.65 37.3471C104.671 37.3262 104.698 37.3143 104.727 37.314H143.068C143.097 37.3143 143.125 37.326 143.145 37.3466C143.165 37.3672 143.177 37.395 143.177 37.424C143.177 37.453 143.165 37.4808 143.145 37.5014C143.125 37.522 143.097 37.5337 143.068 37.534Z",
    fill: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.068 40.1751H104.729C104.7 40.1753 104.672 40.1639 104.652 40.1435C104.631 40.1231 104.619 40.0952 104.619 40.0661C104.619 40.037 104.63 40.009 104.65 39.9882C104.671 39.9674 104.698 39.9555 104.727 39.9551H143.068C143.097 39.9554 143.125 39.9671 143.145 39.9877C143.165 40.0083 143.177 40.0361 143.177 40.0651C143.177 40.0941 143.165 40.1219 143.145 40.1425C143.125 40.1631 143.097 40.1749 143.068 40.1751Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M143.068 42.8158H104.729C104.7 42.8159 104.672 42.8045 104.652 42.7841C104.631 42.7637 104.619 42.7359 104.619 42.7067C104.619 42.6776 104.63 42.6496 104.65 42.6288C104.671 42.608 104.698 42.5961 104.727 42.5957H143.068C143.097 42.596 143.125 42.6077 143.145 42.6283C143.165 42.6489 143.177 42.6767 143.177 42.7057C143.177 42.7347 143.165 42.7625 143.145 42.7831C143.125 42.8037 143.097 42.8155 143.068 42.8158Z",
    fill: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.068 45.4564H104.729C104.7 45.4565 104.672 45.4452 104.652 45.4247C104.631 45.4043 104.619 45.3765 104.619 45.3474C104.619 45.3183 104.63 45.2902 104.65 45.2694C104.671 45.2486 104.698 45.2367 104.727 45.2363H143.068C143.097 45.2366 143.125 45.2483 143.145 45.2689C143.165 45.2895 143.177 45.3174 143.177 45.3464C143.177 45.3754 143.165 45.4032 143.145 45.4238C143.125 45.4444 143.097 45.4561 143.068 45.4564Z",
    fill: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.571 114.971V102.499C184.571 101.948 184.353 101.419 183.965 101.029C183.577 100.639 183.051 100.42 182.502 100.42H135.424C134.875 100.42 134.349 100.639 133.961 101.029C133.573 101.419 133.355 101.948 133.355 102.499V114.971H184.571Z",
    fill: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M184.572 119.648H133.355V135.758H184.572V119.648Z",
    fill: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M133.355 140.435V152.907C133.355 153.458 133.573 153.987 133.961 154.376C134.349 154.766 134.875 154.985 135.424 154.985H182.502C183.051 154.985 183.577 154.766 183.965 154.376C184.353 153.987 184.571 153.458 184.571 152.907V140.435H133.355Z",
    fill: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.705 109.774C159.562 109.774 160.257 109.076 160.257 108.215C160.257 107.354 159.562 106.656 158.705 106.656C157.847 106.656 157.153 107.354 157.153 108.215C157.153 109.076 157.847 109.774 158.705 109.774Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M158.705 130.561C159.562 130.561 160.257 129.863 160.257 129.002C160.257 128.141 159.562 127.443 158.705 127.443C157.847 127.443 157.153 128.141 157.153 129.002C157.153 129.863 157.847 130.561 158.705 130.561Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M158.788 150.908C159.645 150.908 160.34 150.21 160.34 149.349C160.34 148.488 159.645 147.79 158.788 147.79C157.93 147.79 157.236 148.488 157.236 149.349C157.236 150.21 157.93 150.908 158.788 150.908Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M178.765 86.1996V100.504H143.088C141.2 100.568 139.365 99.8777 137.984 98.5832C136.603 97.2887 135.791 95.4966 135.725 93.6006C135.659 91.7046 136.346 89.86 137.633 88.4722C138.921 87.0844 140.705 86.267 142.592 86.1996C142.757 86.1939 142.923 86.1939 143.088 86.1996H178.765Z",
    fill: "#F2F2F2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M179.641 100.394C179.641 100.54 179.583 100.68 179.481 100.783C179.378 100.886 179.239 100.944 179.093 100.944H142.452C140.463 100.945 138.554 100.151 137.147 98.7387C135.74 97.3261 134.948 95.4099 134.947 93.4114C134.946 91.4128 135.735 89.4956 137.141 88.0814C138.546 86.6671 140.454 85.8715 142.443 85.8696H179.093C179.165 85.8694 179.237 85.8835 179.303 85.9111C179.37 85.9387 179.431 85.9792 179.482 86.0303C179.533 86.0814 179.573 86.1421 179.601 86.2089C179.628 86.2758 179.643 86.3474 179.643 86.4198C179.643 86.4922 179.628 86.5638 179.601 86.6307C179.573 86.6975 179.533 86.7582 179.482 86.8093C179.431 86.8604 179.37 86.9009 179.303 86.9285C179.237 86.956 179.165 86.9701 179.093 86.97H142.452C140.754 86.9722 139.127 87.6513 137.927 88.8582C136.727 90.0651 136.053 91.7011 136.053 93.4068C136.053 95.1125 136.727 96.7485 137.927 97.9554C139.127 99.1623 140.754 99.8415 142.452 99.8437H179.093C179.239 99.8438 179.378 99.9017 179.481 100.005C179.583 100.108 179.641 100.248 179.641 100.394Z",
    fill: "#3F3D56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M178.765 89.5008H140.426C140.397 89.501 140.369 89.4896 140.349 89.4692C140.328 89.4487 140.316 89.4209 140.316 89.3918C140.316 89.3627 140.327 89.3347 140.347 89.3139C140.367 89.293 140.395 89.2811 140.424 89.2808H178.765C178.794 89.2811 178.821 89.2928 178.842 89.3134C178.862 89.334 178.873 89.3618 178.873 89.3908C178.873 89.4198 178.862 89.4476 178.842 89.4682C178.821 89.4888 178.794 89.5005 178.765 89.5008Z",
    fill: "#CCCCCC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M178.765 92.1415H140.426C140.397 92.1416 140.369 92.1302 140.349 92.1098C140.328 92.0894 140.316 92.0615 140.316 92.0324C140.316 92.0033 140.327 91.9753 140.347 91.9545C140.367 91.9337 140.395 91.9218 140.424 91.9214H178.765C178.794 91.9217 178.821 91.9334 178.842 91.954C178.862 91.9746 178.873 92.0024 178.873 92.0314C178.873 92.0604 178.862 92.0882 178.842 92.1088C178.821 92.1294 178.794 92.1412 178.765 92.1415Z",
    fill: "#CCCCCC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M178.765 94.7821H140.426C140.397 94.7822 140.369 94.7708 140.349 94.7504C140.328 94.73 140.316 94.7022 140.316 94.6731C140.316 94.6439 140.327 94.6159 140.347 94.5951C140.367 94.5743 140.395 94.5624 140.424 94.562H178.765C178.794 94.5623 178.821 94.574 178.842 94.5946C178.862 94.6152 178.873 94.6431 178.873 94.672C178.873 94.701 178.862 94.7289 178.842 94.7495C178.821 94.7701 178.794 94.7818 178.765 94.7821Z",
    fill: "#CCCCCC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M178.765 97.4232H140.426C140.397 97.4233 140.369 97.412 140.349 97.3915C140.328 97.3711 140.316 97.3433 140.316 97.3142C140.316 97.2851 140.327 97.257 140.347 97.2362C140.367 97.2154 140.395 97.2035 140.424 97.2031H178.765C178.794 97.2034 178.821 97.2151 178.842 97.2357C178.862 97.2563 178.873 97.2842 178.873 97.3131C178.873 97.3421 178.862 97.37 178.842 97.3906C178.821 97.4112 178.794 97.4229 178.765 97.4232Z",
    fill: "#CCCCCC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M136.864 29.4614H120.609C120.455 29.4613 120.303 29.4968 120.164 29.5653L116.062 31.6284C115.927 31.686 115.812 31.7823 115.731 31.9052C115.65 32.0281 115.607 32.1722 115.607 32.3195C115.607 32.4669 115.65 32.611 115.731 32.7339C115.812 32.8568 115.927 32.953 116.062 33.0107L120.164 35.0737C120.303 35.1423 120.455 35.1778 120.609 35.1777H136.864C137.088 35.1907 137.308 35.1146 137.477 34.9657C137.645 34.8169 137.749 34.6074 137.764 34.3826V30.2565C137.749 30.0316 137.645 29.8221 137.477 29.6733C137.308 29.5245 137.088 29.4484 136.864 29.4614Z",
    fill: "#3F3D56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M137.764 30.2565V34.3826C137.749 34.6074 137.645 34.817 137.477 34.9658C137.308 35.1146 137.088 35.1907 136.864 35.1777H133.626V29.4614H136.864C137.088 29.4484 137.308 29.5245 137.477 29.6733C137.645 29.8222 137.749 30.0317 137.764 30.2565Z",
    fill: "#FF0000"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4115 110.311C41.5046 111.05 43.7518 111.235 45.9368 110.848C48.1217 110.462 50.1707 109.517 51.8864 108.104C56.2557 104.42 57.6257 98.3507 58.7403 92.7311C59.8393 87.1905 60.9383 81.65 62.0373 76.1094L55.1348 80.8835C50.1709 84.3168 45.0952 87.8601 41.6582 92.8331C38.2213 97.806 36.721 104.595 39.4825 109.976",
    fill: "#E6E6E6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0016 130.435C39.303 125.324 38.5846 120.146 39.0746 114.98C39.5098 110.391 40.9034 105.91 43.7406 102.235C45.2466 100.289 47.079 98.6206 49.1556 97.3063C49.6971 96.963 50.1955 97.825 49.6564 98.1669C46.0633 100.448 43.2841 103.816 41.7197 107.786C39.9917 112.201 39.7143 117.013 40.012 121.703C40.1921 124.539 40.5737 127.357 40.9583 130.17C40.9886 130.298 40.9697 130.432 40.9054 130.546C40.8411 130.659 40.7361 130.744 40.6118 130.783C40.485 130.818 40.3498 130.8 40.2355 130.735C40.1213 130.67 40.0372 130.562 40.0016 130.435Z",
    fill: "#F2F2F2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7305 121.39C47.6281 122.761 48.862 123.876 50.3133 124.628C51.7646 125.381 53.3843 125.745 55.0164 125.686C59.2108 125.486 62.7077 122.545 65.8555 119.753L75.1661 111.496L69.004 111.2C64.5726 110.987 60.0269 110.788 55.8061 112.161C51.5854 113.533 47.6927 116.837 46.921 121.225",
    fill: "#E6E6E6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0272 133.374C41.3898 127.397 45.2901 120.755 52.2593 118.632C54.1971 118.044 56.229 117.833 58.2456 118.011C58.8811 118.066 58.7224 119.05 58.088 118.995C54.7078 118.713 51.3341 119.61 48.5349 121.534C45.8413 123.376 43.744 125.936 41.9689 128.651C40.8816 130.315 39.9076 132.048 38.9335 133.78C38.6222 134.333 37.7123 133.934 38.0272 133.374Z",
    fill: "#F2F2F2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6393 139.664C32.7526 138.346 33.224 137.083 34.002 136.015C34.7801 134.947 35.835 134.114 37.0519 133.606V130.151H42.8211V133.715C43.9782 134.248 44.9739 135.079 45.7069 136.124C46.4399 137.169 46.8838 138.391 46.9935 139.664L48.3501 155.505H31.2827L32.6393 139.664Z",
    fill: "#F2F2F2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M228.84 64.0298L227.124 63.3039L225.947 54.6616H210.269L208.992 63.2686L207.457 64.0397C207.383 64.0766 207.325 64.1374 207.29 64.2121C207.255 64.2868 207.246 64.3712 207.265 64.4515C207.284 64.5318 207.329 64.6033 207.394 64.6545C207.458 64.7057 207.538 64.7336 207.62 64.7336H228.699C228.783 64.7336 228.865 64.7043 228.93 64.6508C228.995 64.5972 229.04 64.5227 229.056 64.4398C229.073 64.3569 229.061 64.2708 229.021 64.1961C228.982 64.1213 228.918 64.0626 228.84 64.0298Z",
    fill: "#E6E6E6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M256.702 55.8115H179.685C179.281 55.8106 178.894 55.6487 178.609 55.3614C178.323 55.074 178.163 54.6847 178.163 54.2788V43.3696H258.224V54.2788C258.224 54.6847 258.064 55.074 257.779 55.3614C257.493 55.6487 257.106 55.8106 256.702 55.8115Z",
    fill: "#CCCCCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M258.305 48.5256H178.093V1.84763C178.093 1.35777 178.287 0.888139 178.632 0.541762C178.977 0.195385 179.444 0.000548121 179.932 0H256.465C256.953 0.000548112 257.421 0.195386 257.765 0.541762C258.11 0.888139 258.304 1.35777 258.305 1.84763L258.305 48.5256Z",
    fill: "#3F3D56"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M253.514 45.1376H182.883C182.507 45.1372 182.147 44.987 181.881 44.72C181.615 44.4529 181.466 44.0909 181.465 43.7132V4.81218C181.466 4.43452 181.615 4.07245 181.881 3.8054C182.147 3.53834 182.507 3.38813 182.883 3.3877H253.514C253.89 3.38813 254.251 3.53835 254.516 3.8054C254.782 4.07245 254.932 4.43452 254.932 4.81218V43.7132C254.932 44.0909 254.782 44.4529 254.516 44.72C254.251 44.987 253.89 45.1372 253.514 45.1376Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M222.688 22.435V22.8291C222.688 24.6188 221.73 25.9437 219.297 25.9437C217.193 25.9437 216.037 25.069 215.734 23.6469C213.829 23.8362 212.021 23.889 210.5 23.7724C210.743 25.6505 211.743 27.3653 213.764 28.5231C215.36 29.4376 217.316 29.8345 219.272 29.8345C221.312 29.8345 223.34 29.4221 224.947 28.3957C227.097 27.0228 227.9 24.9479 227.9 22.8291V20.6892C226.449 21.3504 224.641 21.9453 222.688 22.435Z",
    fill: "url(#paint0_linear_146_4309)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M210.44 14.0642V22.12C210.923 22.147 211.449 22.1569 212.013 22.1495C212.898 22.1379 214.179 22.0501 215.652 21.8901V14.0642H210.44Z",
    fill: "url(#paint1_linear_146_4309)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M222.689 14.0643V20.7422C224.737 20.2789 226.616 19.707 227.901 19.034V14.0643H222.689Z",
    fill: "url(#paint2_linear_146_4309)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_146_4309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 195,
    y: 6,
    width: 48,
    height: 37
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 6H242.38V42.9736H195.5V6Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_146_4309)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_146_4309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 210,
    y: 14,
    width: 6,
    height: 5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_146_4309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 210,
    y: 14,
    width: 6,
    height: 5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M210.44 14.0641H215.652V18.9233H210.44V14.0641Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_146_4309)"
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M210.44 14.0641H215.652V18.9233H210.44V14.0641Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_146_4309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 210,
    y: 14,
    width: 6,
    height: 5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M210.44 14.0641H215.652V18.9233H210.44V14.0641Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_146_4309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.44 18.9233H215.652V14.0641H210.44V18.9233Z",
    fill: "url(#paint3_linear_146_4309)"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_146_4309)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_146_4309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 210,
    y: 14,
    width: 6,
    height: 5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M210.44 14.0641H215.652V18.9233H210.44V14.0641Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_146_4309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.44 18.9233V14.0641H215.652V15.6603C211.535 17.0774 210.44 18.9233 210.44 18.9233Z",
    fill: "#FCE2A6"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_146_4309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 14,
    width: 5,
    height: 1
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_146_4309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 14,
    width: 5,
    height: 1
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M222.688 14.0642H226.877V14.2617H222.688V14.0642Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_146_4309)"
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M222.688 14.0643H226.877V14.2617H222.688V14.0643Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_146_4309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 14,
    width: 5,
    height: 1
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M222.688 14.0643H226.877V14.2617H222.688V14.0643Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_146_4309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.688 14.2617H226.877V14.0643H222.688V14.2617Z",
    fill: "url(#paint4_linear_146_4309)"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_146_4309)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_146_4309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 14,
    width: 5,
    height: 1
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M222.688 14.0643H226.877V14.2617H222.688V14.0643Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_146_4309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.688 14.0647H226.877C225.348 14.0765 223.956 14.1466 222.688 14.2622V14.0647Z",
    fill: "#FCE2A6"
  }))))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M228.871 16.8631C229.364 17.042 229.675 17.2764 229.77 17.5663C230.879 20.9317 216.628 22.883 212.213 22.9406C209.448 22.9767 207.585 22.5989 207.324 21.8087C207.255 21.5986 207.303 21.3705 207.456 21.1295C206.645 21.7191 206.274 22.2716 206.418 22.7456C207.805 27.2996 232.899 22.7421 231.428 17.978C231.254 17.4145 230.321 17.0449 228.871 16.8631H228.871Z",
    fill: "url(#paint5_linear_146_4309)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_146_4309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 25,
    width: 16,
    height: 5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_146_4309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 25,
    width: 16,
    height: 5
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M212.352 25.0265H227.577V29.835H212.352V25.0265Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_146_4309)"
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M212.352 25.0265H227.577V29.835H212.352V25.0265Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_146_4309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 25,
    width: 16,
    height: 5
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M212.352 25.026H227.577V29.8345H212.352V25.026Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_146_4309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.352 29.835H227.577V25.0265H212.352V29.835Z",
    fill: "url(#paint6_linear_146_4309)"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_146_4309)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_146_4309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 25,
    width: 16,
    height: 5
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M212.352 25.0265H227.577V29.835H212.352V25.0265Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_146_4309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.106 27.229C223.236 28.2554 220.877 28.6678 218.503 28.6678C216.332 28.6678 214.16 28.3063 212.352 27.4785C212.753 27.8619 213.222 28.2128 213.764 28.5236C215.36 29.438 217.317 29.835 219.272 29.835C221.312 29.835 223.34 29.4226 224.947 28.3962C226.339 27.5076 227.166 26.3249 227.577 25.0265C227.028 25.8617 226.223 26.6155 225.106 27.229Z",
    fill: "#F3F3F3"
  })))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M211.647 32.3952C211.489 32.3952 211.355 32.4392 211.243 32.5269C211.129 32.6168 211.072 32.723 211.072 32.8455V35.6419C211.072 35.7461 211.028 35.837 210.94 35.9145C210.842 35.9983 210.722 36.0401 210.579 36.0401C210.437 36.0401 210.316 35.9983 210.218 35.9145C210.127 35.8329 210.082 35.742 210.082 35.6419V32.8455C210.082 32.721 210.026 32.6148 209.915 32.5269C209.804 32.4392 209.669 32.3952 209.511 32.3952H209.259V35.6327C209.259 35.9145 209.391 36.1677 209.655 36.3923C209.914 36.5904 210.222 36.6895 210.579 36.6895C210.944 36.6895 211.255 36.5884 211.511 36.3862C211.77 36.1821 211.9 35.936 211.9 35.6481V32.3952H211.647Z",
    fill: "url(#paint7_linear_146_4309)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M214.602 34.8149L213.394 32.3952H213.88C214.123 32.3952 214.303 32.4953 214.42 32.6954L215.018 34.04L215.612 32.6985C215.728 32.4963 215.908 32.3952 216.152 32.3952H216.637L215.429 34.8149V36.2392C215.429 36.3638 215.374 36.47 215.262 36.5577C215.151 36.6456 215.015 36.6895 214.855 36.6895H214.602V34.8149Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M218.955 35.6481C218.955 35.7543 219.004 35.8461 219.102 35.9237C219.201 36.0014 219.317 36.0401 219.452 36.0401C219.586 36.0401 219.703 36.0014 219.801 35.9237C219.897 35.8482 219.945 35.7563 219.945 35.6481V33.4366C219.945 33.3284 219.897 33.2365 219.801 33.161C219.703 33.0834 219.586 33.0446 219.452 33.0446C219.317 33.0446 219.201 33.0834 219.102 33.161C219.004 33.2386 218.955 33.3305 218.955 33.4366V35.6481ZM218.131 33.4366C218.131 33.1487 218.26 32.9027 218.516 32.6985C218.777 32.4963 219.089 32.3952 219.452 32.3952C219.817 32.3952 220.128 32.4963 220.384 32.6985C220.643 32.9027 220.772 33.1487 220.772 33.4366V35.6481C220.772 35.936 220.643 36.1821 220.384 36.3862C220.128 36.5884 219.817 36.6895 219.452 36.6895C219.092 36.6895 218.781 36.5884 218.52 36.3862C218.261 36.1821 218.131 35.936 218.131 35.6481V33.4366Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M223.09 35.6481C223.09 35.7543 223.139 35.8461 223.238 35.9237C223.336 36.0014 223.452 36.0401 223.587 36.0401C223.722 36.0401 223.838 36.0014 223.937 35.9237C224.032 35.8482 224.08 35.7563 224.08 35.6481V33.4366C224.08 33.3284 224.032 33.2365 223.937 33.161C223.838 33.0834 223.722 33.0446 223.587 33.0446C223.452 33.0446 223.336 33.0834 223.238 33.161C223.139 33.2386 223.09 33.3305 223.09 33.4366V35.6481ZM222.267 33.4366C222.267 33.1487 222.395 32.9027 222.651 32.6985C222.913 32.4963 223.225 32.3952 223.587 32.3952C223.952 32.3952 224.263 32.4963 224.519 32.6985C224.778 32.9027 224.907 33.1487 224.907 33.4366V35.6481C224.907 35.936 224.778 36.1821 224.519 36.3862C224.263 36.5884 223.952 36.6895 223.587 36.6895C223.227 36.6895 222.916 36.5884 222.655 36.3862C222.396 36.1821 222.267 35.936 222.267 35.6481V33.4366Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M228.546 35.1733V32.9588C228.546 32.8037 228.616 32.6709 228.755 32.5606C228.895 32.4504 229.065 32.3952 229.264 32.3952H229.373V36.6895H228.883C228.645 36.6895 228.465 36.5894 228.344 36.3893L227.225 33.9236V36.2392C227.225 36.3638 227.169 36.47 227.058 36.5577C226.947 36.6456 226.812 36.6895 226.654 36.6895H226.402V32.3952H226.771C227.071 32.3952 227.295 32.5188 227.443 32.7659L228.546 35.1733Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M234.911 58.864C235.367 58.4409 235.91 58.1234 236.501 57.9338C237.093 57.7443 237.718 57.6872 238.334 57.7668C238.95 57.8463 239.54 58.0605 240.065 58.3943C240.589 58.728 241.034 59.1732 241.369 59.6984L250.923 57.9923L253.371 63.5712L239.845 65.7903C238.93 66.2964 237.861 66.4475 236.842 66.215C235.823 65.9825 234.924 65.3825 234.316 64.5288C233.707 63.675 233.432 62.6268 233.542 61.5827C233.651 60.5387 234.139 59.5714 234.911 58.864Z",
    fill: "#FFB6B6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M243.756 65.9872L253.716 65.8625L254.977 65.8454L275.241 65.5889C275.241 65.5889 280.743 60.3156 285.535 54.8863L284.863 50.0068C284.208 45.2181 281.843 40.8316 278.209 37.6636C271.346 42.2698 267.367 51.3872 267.367 51.3872L254.802 54.4058L253.545 54.7078L245.738 56.5817L243.756 65.9872Z",
    fill: "#FF6161"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M294.742 95.9785H276.151C276.151 96.7787 255.828 97.4281 255.828 97.4281C255.379 97.7672 254.971 98.1562 254.61 98.5878C253.525 99.8875 252.932 101.53 252.936 103.227V104.386C252.936 106.308 253.697 108.151 255.05 109.511C256.403 110.87 258.238 111.634 260.151 111.634H294.742C296.655 111.633 298.489 110.868 299.842 109.509C301.195 108.151 301.956 106.308 301.958 104.386V103.227C301.955 101.305 301.194 99.463 299.841 98.1044C298.489 96.7457 296.655 95.9812 294.742 95.9785Z",
    fill: "#E4E4E4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M281.222 111.347H273.718V154.856H281.222V111.347Z",
    fill: "#E4E4E4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M252.36 154.591C252.36 155.405 263.732 154.906 277.759 154.906C291.786 154.906 303.158 155.405 303.158 154.591C303.158 153.777 291.786 147.318 277.759 147.318C263.732 147.318 252.36 153.777 252.36 154.591Z",
    fill: "#E4E4E4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M247.319 149.62L241.734 149.619L239.077 127.98L247.32 127.981L247.319 149.62Z",
    fill: "#FFB6B6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M248.743 155.058L230.735 155.057V154.828C230.735 152.961 231.474 151.17 232.788 149.85C234.103 148.53 235.885 147.788 237.744 147.788H237.745L248.744 147.788L248.743 155.058Z",
    fill: "#2F2E41"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M230.812 149.62L225.227 149.619L222.571 127.98L230.813 127.981L230.812 149.62Z",
    fill: "#FFB6B6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M232.237 155.058L214.229 155.057V154.828C214.229 152.961 214.967 151.17 216.282 149.85C217.596 148.53 219.379 147.788 221.238 147.788H221.238L232.237 147.788L232.237 155.058Z",
    fill: "#2F2E41"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M280.841 25.0433C286.204 25.0433 290.552 20.6761 290.552 15.289C290.552 9.90182 286.204 5.53467 280.841 5.53467C275.478 5.53467 271.13 9.90182 271.13 15.289C271.13 20.6761 275.478 25.0433 280.841 25.0433Z",
    fill: "#FFB6B6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M296.557 82.1214C296.557 82.1214 299.816 99.4278 287.419 101.632C275.022 103.836 257.126 105.384 257.126 105.384L249.09 143.047L238.293 142.079C238.293 142.079 239.729 96.7415 243.26 93.1945C246.792 89.6475 269.11 79.0269 269.11 79.0269L296.557 82.1214Z",
    fill: "#2F2E41"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M272.345 74.8682L266.923 80.3318C266.923 80.3318 227.774 86.666 226.264 95.7488C223.984 109.462 221.291 139.281 221.291 139.281L233.061 138.394L237.677 104.498L256.51 100.195L277.936 88.4651L272.345 74.8682Z",
    fill: "#2F2E41"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M290.185 9.46644C289.227 7.64971 288.009 4.029 286.074 3.35749C284.999 2.99962 283.889 2.76198 282.763 2.6489L279.474 3.91944L281.264 2.52114C280.915 2.50029 280.567 2.48324 280.219 2.47L278 3.32724L279.135 2.44034C277.067 2.41901 274.931 2.63507 273.329 3.90003C271.962 4.97841 270.608 9.06354 270.389 10.7951C270.155 12.4517 270.237 14.1378 270.631 15.7636L271.193 16.3003C271.389 15.8475 271.537 15.375 271.633 14.8907C271.835 13.9857 272.222 13.1329 272.77 12.3864C273.317 11.64 274.014 11.0164 274.815 10.5553L274.845 10.538C275.788 10.0052 276.931 10.0298 278.012 10.0688L283.145 10.2544C284.38 10.299 285.71 10.3775 286.673 11.1556C287.285 11.7297 287.766 12.4298 288.083 13.208C288.562 14.178 289.496 17.8363 289.496 17.8363C289.496 17.8363 290.025 17.1457 290.279 17.6597C290.685 16.3187 290.933 14.9341 291.015 13.5348C291.096 12.1292 290.81 10.7268 290.185 9.46644Z",
    fill: "#2F2E41"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M324.149 19.5722C323.529 19.6132 322.926 19.7901 322.382 20.0905C321.838 20.3908 321.367 20.8074 321 21.3107C320.634 21.8141 320.382 22.392 320.262 23.0038C320.142 23.6156 320.157 24.2464 320.306 24.8518L312.497 30.6378L314.84 36.2621L325.753 27.9355C326.749 27.6168 327.594 26.9422 328.128 26.0395C328.661 25.1369 328.847 24.069 328.649 23.0381C328.451 22.0072 327.884 21.085 327.055 20.4462C326.225 19.8074 325.191 19.4965 324.149 19.5722Z",
    fill: "#FFB6B6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M322.892 31.3847L303.316 53.2237C303.316 53.2237 293.955 50.2133 286.714 46.9496L283.462 36.9148C282.707 34.5869 282.384 32.1392 282.511 29.6941C292.548 27.0113 304.222 36.9935 304.222 36.9935L318.875 25.4639L322.892 31.3847Z",
    fill: "#FF6161"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M277.214 83.7345C273.721 82.5227 270.11 81.2696 266.214 80.7992L266.047 80.7789L266.093 80.6162C270.126 66.3943 269.119 57.2966 267.143 43.6307C266.723 40.683 267.263 37.6778 268.683 35.0636C270.102 32.4495 272.325 30.3666 275.02 29.1259L275.044 29.115L286.17 28.4049L286.195 28.4033L294.286 30.7938C295.45 31.1402 296.469 31.8604 297.187 32.844C297.904 33.8277 298.281 35.0205 298.259 36.2397C298.171 40.734 298.357 45.7518 298.554 51.064C298.996 62.9817 299.452 75.3053 296.861 83.3011L296.848 83.343L296.813 83.3703C294.431 85.3188 291.448 86.3717 288.376 86.3474C284.744 86.3473 281.038 85.0614 277.214 83.7345Z",
    fill: "#FF6161"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M357.983 156H1.01734C0.880135 156 0.748548 155.945 0.651528 155.848C0.554508 155.75 0.5 155.618 0.5 155.48C0.5 155.342 0.554508 155.21 0.651528 155.113C0.748548 155.015 0.880135 154.96 1.01734 154.96H357.983C358.12 154.96 358.251 155.015 358.348 155.113C358.445 155.21 358.5 155.342 358.5 155.48C358.5 155.618 358.445 155.75 358.348 155.848C358.251 155.945 358.12 156 357.983 156Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_146_4309",
    x1: 218.953,
    y1: 24.1185,
    x2: 220.223,
    y2: 33.5568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99957,
    stopColor: "#9D9C9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9C9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_146_4309",
    x1: 214.521,
    y1: 23.4901,
    x2: 212.329,
    y2: 10.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B61C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998343,
    stopColor: "#FFCE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_146_4309",
    x1: 226.408,
    y1: 21.4632,
    x2: 224.216,
    y2: 8.60665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B61C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998343,
    stopColor: "#FFCE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_146_4309",
    x1: 212.324,
    y1: 8.21129,
    x2: 212.909,
    y2: 18.9912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_146_4309",
    x1: 224.207,
    y1: 7.56684,
    x2: 224.792,
    y2: 18.3466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_146_4309",
    x1: 219.945,
    y1: 24.5318,
    x2: 219.403,
    y2: 18.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00478F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998492,
    stopColor: "#47EADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47EADF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_146_4309",
    x1: 221.188,
    y1: 33.6489,
    x2: 220.373,
    y2: 26.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_146_4309",
    x1: 209.259,
    y1: 34.5423,
    x2: 211.9,
    y2: 34.5423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B61C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998343,
    stopColor: "#FFCE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE4B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_4309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 358,
    height: 156,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactImg);
export default __webpack_public_path__ + "static/media/contact-img.870fbdc5814b47076c0ff83b4bf7be22.svg";
export { ForwardRef as ReactComponent };